import React, { Component } from "react";
import "./InsertPhone.css";
import Button from "../components/Button";
import { Scrollbars } from 'react-custom-scrollbars';

class InsertPhone extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      firstBlur:true,
    }
    this.state = this.initialState;
  }

  handleClick = () => {
    this.props.callTerms(false);
  };

  render() {

    return (
      <React.Fragment>
      
        <Scrollbars style={{ width: '100%', height: '90vh' }}><br/><br/>
          <center><b>Termos de uso da rede Netlivre e política de privacidade</b></center>
          <br/>
          <p align='justify'>

<br/>O acesso à rede é permitido somente aos visitantes devidamente autenticados. O acesso é obtido por meio do cadastro, é pessoal e intransferível, sendo o visitante o único responsável por qualquer ato (legal ou ilegal) decorrente do uso da rede a partir da validação do seu login através do número do telefone. 

<br/>Ao utilizar a rede da Netlivre para acesso à Internet, o USUÁRIO expressamente aceita, sem reservas ou ressalvas, todas as condições abaixo descritas para a utilização do serviço. o serviço poderá ser interrompido a qualquer momento sem prévio aviso, devido a:

<br/><br/>1) Manutenções técnicas e/ou operacionais que exijam o desligamento temporário do sistema ou impossibilitem o acesso;
<br/>2) Casos fortuitos ou força maior;
<br/>3) Ações de terceiros que impeçam a prestação dos serviços;
<br/>4) Falta de fornecimento de energia elétrica para a prestação do serviço;
<br/>5) Ocorrências de falhas no sistema de transmissão e/ou roteamento no acesso à Internet;
<br/>6) Interrupção na prestação do serviço.

<br/><br/>O visitante deve conhecer as regras e penalidades envolvidas na utilização desta rede, abaixo descritas.

<br/><br/><b>REGRAS:</b>

<br/><br/>1) Não se fazer passar por outra pessoa ou dissimular sua identidade quando realizar o acesso por meio de quaisquer dispositivos.
<br/>2) Responsabilizar-se pela sua identidade eletrônica, senha ou outro dispositivo de segurança, negando revelá-la a terceiros;
<br/>3) Manter seus dispositivos pessoais (notebooks, smartphones, etc.) com softwares e antivírus atualizados;
<br/>4) Não usar a rede para trafegar informações confidenciais e/ou sigilosas, salvo quando utilizado algum meio seguro de transmissão (vpn, conexões cifradas, etc.);
<br/>5) Responder pelo mau uso dos recursos em qualquer circunstância;
<br/>6) Responder por atos que violem as regras de uso dos recursos e dados, estando, portanto, sujeito às penalidades definidas na política de uso desses recursos.

<br/><br/><b>CONSIDERA-SE VIOLAÇÃO DAS REGRAS:</b>

<br/><br/>1) Infringir qualquer lei ou regulamento local, estadual, nacional ou internacional aplicável;
<br/>2) Acessar, mostrar, armazenar ou transmitir qualquer forma de mídia que possa ser considerada ofensiva ou abusiva;
<br/>3) Utilizar os recursos da rede Netlivre para constranger, assediar, ameaçar ou perseguir qualquer pessoa;
<br/>4) Utilizar os recursos da rede Netlivre para invadir, alterar ou destruir recursos ou dados de outras instituições;
<br/>5) Violar ou tentar violar os sistemas de segurança, quebrando ou tentando adivinhar a identidade eletrônica de outro usuário, senhas ou outros dispositivos de segurança;
<br/>6) Interceptar ou tentar interceptar a transmissão de dados através de monitoração;
<br/>7) Utilizar os recursos da rede Netlivre para fins comerciais ou políticos, tais como mala direta, spams ou propaganda política;

<br/><br/><b>UTILIZAÇÃO DAS INFORMAÇÕES COLETADAS:</b> 

<br/><br/>Ao aceitar os  termos o usuário permite por meio do uso de cookies ou outra tecnologia, armazenar informações a respeito da navegação do usuário no site e/ou aplicativo. As informações dos usuários são coletadas, armazenadas, tratadas, processadas e utilizadas pela Valenet com as seguintes finalidades:

<br/><br/>1. Desenvolver, manter e aperfeiçoar os recursos, serviços e funcionalidades do site e/ou aplicativo;
<br/>2. Possibilitar o acesso e o uso dos recursos, serviços e funcionalidades do site e/ou aplicativo pelos usuários;
<br/>3. Analisar o desempenho do site e/ou aplicativo, medir a audiência do site e/ou aplicativo, verificar os hábitos de navegação dos usuários no site e/ou aplicativo, a forma pela qual chegaram à página do site e/ou aplicativo (por exemplo, através de links de outros sites, buscadores ou diretamente pelo endereço), avaliar estatísticas relacionadas ao número de acessos e uso do site e/ou aplicativo, seus recursos, serviços e funcionalidades;
<br/>4. Melhorar as experiências de navegação dos usuários no site e/ou aplicativo;
<br/>5. Permitir o fornecimento de serviços mais personalizados e adequados às necessidades dos usuários, tais como páginas de perfil, atualizações, conteúdos e anúncios relevantes;
<br/>6. Permitir a comunicação entre os usuários e a Valenet, inclusive mediante o envio e recebimento de mensagens, tais como e-mails, mensagens de texto (SMS) e push messages (mensagens personalizadas enviadas automaticamente para os aparelhos dos clientes), mas não restrito a apenas estes; 
<br/>7. Identificar os perfis, hábitos e necessidades para eventuais ofertas de serviços e estratégias da Valenet.

<br/><br/>A Valenet preserva a privacidade dos usuários e não compartilha seus dados e informações com terceiros, salvo mediante consentimento do próprio usuário ou ordem judicial. O usuário poderá desabilitar os cookies por meio das opções de configuração do seu respectivo navegador. Contudo, ao decidir pela proibição dos cookies, o usuário está ciente e reconhece que é possível que o site e/ou aplicativo não desempenhe todas as suas funcionalidades.
<br/><br/><b>PENALIDADES:</b>

<br/><br/>- A violação das regras está sujeita às penas previstas em lei.

<br/><br/><br/><br/>
</p>
     
      </Scrollbars>
      <Button 
        ref={input => {
          this.button = input;
        }}
        label="retornar" onClick={this.handleClick} 
          />
      <br/><br/>
     
    </React.Fragment>
    );
  }
}

export default InsertPhone;